import { RegionRecommendation } from '../../models/region-recommendation';
import { createStringIdAdapter } from './common/string-id-adapter';

export const devBoxRegionRecommendationAdapter = createStringIdAdapter<RegionRecommendation>();
